<template>
    <div class="history wow fadeInUp" v-if="isLast">
        <div class="content">
            <swiper class="swiper" :options="swiperOption" ref="mySwipers" v-if="list.length>0">
                <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                    <div class="con-box">
                        <div class="time-bg">
                            {{item.title}}
                        </div>
                        <div class="img">
                            <img :src="`http://www.znr.com.cn/${item.picurl}`" alt="">
                        </div>
                        <div class="text">
                            <div class="year">
                                <span>{{item.title}}</span>
                                <span>{{$t('about').history.text0}}</span>
                            </div>
                            <div class="t1">
                                {{item.description}}
                            </div>
                            <aboutDia2 class="acontent" :id="item.id"/>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="btn prev ">
                <i class="el-icon-arrow-up"></i>
            </div>
            <div class="btn next ">
                <i class="el-icon-arrow-down"></i>
            </div>
        </div>
        <div class="tSwiper">
            <swiper class="swiper" :options="swiperOption2" ref="mySwipers2" v-if="list.length>0">
                <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                    <div class="con-box">
                        <div class="circle">

                        </div>
                        <div class="time">
                            {{item.title}}
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>

    </div>
</template>

<script>
    import Scrollbar from 'smooth-scrollbar';
    import aboutDia2 from '../components/aboutDia2'
    import {swiper, swiperSlide} from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import {getProductsUrl} from '../util/lang'

    export default {
        name: "history",
        data() {
            let _this = this
            return {
                isLast: true,
                swiperOption: {
                    notNextTick: true,
                    slidesPerView: 1,//一行显示3个
                    speed: 1000,
                    init: false,
                    loop: false,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    setWrapperSize: true,
                    autoplay: false,
                    navigation: {
                        prevEl: '.content .btn.prev',
                        nextEl: '.content .btn.next',
                    },
                },
                swiperOption2: {
                    notNextTick: true,
                    slidesPerView: 4,//一行显示3个
                    speed: 1000,
                    initialSlide: 0,
                    centeredSlides: true,
                    slideToClickedSlide: true,
                    init: false,
                    loop: false,
                    setWrapperSize: true,
                    autoplay: false,
                    on: {
                        slideChangeTransitionEnd: () => {
                            this.$nextTick(() => {
                                let swiper = _this.$refs.mySwipers2.swiper;
                                let active = swiper.realIndex;
                                // if(active===_this.list.length-1 && _this.list.length>1){
                                //     _this.isLast=false
                                //     setTimeout(()=>{
                                //         const link=`/about.html?index=2`
                                //         // this.$emit('getIndex',2)
                                //         window.open(link,'_self')
                                //     },200)
                                //
                                // }
                            });
                        }
                    }
                },
                list: []
            }
        },
        components: {
            swiper, swiperSlide, aboutDia2
        },
        mounted() {
            Scrollbar.initAll();
            if (this.$i18n.locale === 'en') {
                this.getList('103')
            } else {
                this.getList('3')
            }

        },
        methods: {
            getList(id) {
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    this.list = res.data.data
                    // this.list.push({
                    //     title:'更多精彩',
                    //     img:'',
                    //     description:''
                    // })
                    setTimeout(() => {
                        this.$refs.mySwipers.swiper.init()
                        this.$refs.mySwipers2.swiper.init()
                        const swiperTop = this.$refs.mySwipers.swiper
                        const swiperThumbs = this.$refs.mySwipers2.swiper
                        swiperTop.controller.control = swiperThumbs
                        swiperThumbs.controller.control = swiperTop
                    }, 100)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .history {
        width: 100%;
        position: relative;
        animation-duration: 2s;
        padding: 80px 0;
        background-color: #ebf0f5;
        overflow: hidden;
        transition: all 100ms;

        .content {
            width: 1440px;
            margin: 0 auto;
            position: relative;

            .swiper {
                width: 100%;

                .item {
                    .con-box {
                        position: relative;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;

                        .time-bg {
                            font-size: 500px;
                            color: #fff;
                            font-family: "DINEngschriftStd";
                            position: absolute;
                            left: 0;
                            top: -100px;
                            width: 100%;
                            height: 100%;
                            text-align: center;
                            opacity: .7;
                            z-index: -1;
                        }

                        .img {
                            width: 44%;
                            z-index: 3;
                            cursor: pointer;
                            overflow: hidden;

                            img {
                                width: 100%;
                                display: block;
                                object-fit: cover;
                                transition: all 600ms;
                            }

                            &:hover {
                                img {
                                    transform: scale(1.05);
                                }
                            }
                        }

                        .text {
                            width: 50%;
                            z-index: 3;

                            .year {
                                width: 100%;
                                display: flex;
                                flex-direction: row;
                                align-items: center;

                                span:nth-child(1) {
                                    font-family: "DINEngschriftStd";
                                    color: #6D2D79;
                                    font-size: 50px;
                                }

                                span:nth-child(2) {
                                    font-family: "SourceHanSansSC-Medium";
                                    color: #6D2D79;
                                    margin-left: 10px;
                                    margin-top: 15px;
                                }
                            }

                            .t1 {
                                font-family: "SourceHanSansSC-Medium";
                                font-size: 18px;
                                margin-top: 30px;
                            }
                        }
                    }
                }
            }

            .prev {
                position: absolute;
                cursor: pointer;
                z-index: 1000;
                left: 50%;
                top: -30px;

                i {
                    color: #6D2D79;
                    font-size: 25px;
                }
            }

            .next {
                position: absolute;
                cursor: pointer;
                z-index: 1000;
                left: 50%;
                top:250px;

                i {
                    color: #6D2D79;
                    font-size: 25px;
                }
            }

            .btn:focus {
                outline: none;
            }
        }

        .tSwiper {
            background-image: url('../assets/ycb/time.png');
            background-repeat: repeat-x;
            height: 60px;
            position: relative;
            z-index: 3;
            margin: 60px auto;

            .swiper {
                width: 1440px;
                margin: 0 auto;

                .item {
                    padding: 30px 0;

                    .con-box {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;

                        .circle {
                            width: 6px;
                            height: 6px;
                            border-radius: 100%;
                            margin: 0 auto;
                            transition: all .3s;
                            background-color: #737373;
                        }

                        .time {
                            margin-top: 10px;
                            font-size: 18px;
                            color: #737373;
                            font-family: "DINEngschriftStd";
                            white-space: nowrap;
                            transition: all .3s;
                        }
                    }
                }

                .swiper-slide-active {
                    .con-box {
                        .circle {
                            background-color: #6D2D79;
                        }

                        .time {
                            color: #6D2D79;
                        }
                    }
                }
            }
        }

        @media screen and (max-width: 1440px) {
            .content {
                width: 90%;
            }
            .tSwiper {
                .swiper {
                    width: 90%;
                }
            }
        }
        @media screen and (max-width: 1000px) {
            .content {
                .swiper {
                    .item {
                        .con-box {
                            flex-direction: column;

                            .time-bg {
                                font-size: 200px;
                            }

                            .img, .text {
                                width: 100%;
                            }

                            .text {
                                text-align: center;

                                .year {
                                    justify-content: center;
                                    margin: 15px auto;

                                    span:nth-child(1) {
                                        font-size: 30px;
                                    }

                                    span:nth-child(2) {
                                        margin-top: 5px;
                                    }
                                }

                                .t1 {
                                    margin-top: 0;
                                }
                            }

                            .acontent {
                                display: none;
                            }
                        }
                    }
                }

                .prev {
                    left: 47%;
                }

                .next {
                    left: 47%;
                }
            }
        }
    }
</style>
